import { BodySmall } from '@src/fonts/typography/Typography';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 0.25rem;

  p {
    ${BodySmall};
    color: #464646;
  }
`;

export const SelectionTitle = styled.p`
  margin-bottom: 0px;
  font-size: 18px;
  line-height: 28px;
  letter-spacing: 0px;
  color: #464646;
  font-weight: 600;

  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.5rem;
`;

export const SelectionArea = styled.div`
  grid-area: 'selection-area';

  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  overflow: hidden;

  & > div:first-of-type {
    padding: 0px;
  }
`;

export const ImageContainer = styled.div`
  width: 60px;
  height: 60px;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;
